import store from '@state/store'
import formatDate from '@utils/format-date'

export default [
  {
    path: '/login/lineLinkToken/:merchantAlias/:lineLinkToken',
    name: 'line login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (store.getters['auth/loggedIn']) {
            // next({ name: 'member-order', query: { language: routeTo.query.language || routeFrom.query.language }})
            store.dispatch('auth/lineLogIn', {
              lineLinkToken: routeTo.params.lineLinkToken,
              merchantAlias: routeTo.params.merchantAlias,
            })
          }else {
            next()
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Login' } }));
        }
      },
      showDingSomethingLogo: true,
      showLoginButton: false,
      showShareButton: false,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (store.getters['auth/loggedIn']) {
            next({ name: 'member-order', query: { language: routeTo.query.language || routeFrom.query.language }})
          }else {
            next()
          }

        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Login' } }));
        }
      },
      showDingSomethingLogo: true,
      showLoginButton: false,
      showShareButton: false,
    },
  },
  {
    path: '/subscription',
    name: 'subscription', 
    component: () => lazyLoadView(import('@views/subscription')),   
    meta: {
      showDingSomethingLogo: false,
      showLoginButton: false,
      showShareButton: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('merchant/fetchPlans').then(() => next())
      },
    },
  }, 
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    meta: {
      showDingSomethingLogo: false,
      showLoginButton: true,
      showShareButton: false,
    },
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/',
    redirect: '/senji',
    // name: 'home',
    // component: () => lazyLoadView(import('@views/home')),
  },
  {
    path: '/member/booking',
    name: 'member-order',
    component: () => lazyLoadView(import('@views/member-order')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
              currentBooking
            ] = await Promise.all([
            store.dispatch('booking/fetchOrders', {
              page: routeTo.query.p,
              status: routeTo.query.status,
              orderBy: routeTo.query.orderBy,
              merchantAlias: routeTo.query.merchant,
            }),
          ]);

          routeTo.params.orders = currentBooking.items;
          routeTo.params.pagination = currentBooking.pagination;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
        next()
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      orders: route.params.orders || [],
      pagination: route.params.pagination || {},
    }),
  },
  {
    path: '/member/booking/:orderKey',
    name: 'member-order-item',
    component: () => lazyLoadView(import('@views/member-order-item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder
          ] = await Promise.all([
            store.dispatch('booking/fetchOrder', {
              orderKey: routeTo.params.orderKey
            }),
          ]);
          store.dispatch('merchant/updateMerchant', currentOrder.merchant);
          routeTo.params.member = store.state.auth.currentMember;
          routeTo.params.order = currentOrder.items;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
        next()
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      member: route.params.member || {},
      order: route.params.order || {},
    }),
  },
  {
    path: '/member/booking/:orderKey/ticket',
    name: 'member-order-ticket',
    component: () => lazyLoadView(import('@views/member-order-ticket')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder,
            currentTickets
          ] = await Promise.all([
            store.dispatch('booking/fetchOrder', {
              orderKey: routeTo.params.orderKey,
            }),
            store.dispatch('booking/fetchOrderTickets', {
              orderKey: routeTo.params.orderKey
            }),
          ]);
          store.dispatch('merchant/updateMerchant', currentOrder.merchant);
          routeTo.params.order = currentOrder.items;
          routeTo.params.tickets = currentTickets.items
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }

        next()
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      order: route.params.order || {},
      tickets: route.params.tickets || {},
    }),
  },
  {
    path: '/member/prepaid',
    name: 'member-prepaid',
    component: () => lazyLoadView(import('@views/member-prepaid')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrders
          ] = await Promise.all([
            store.dispatch('booking/fetchPrepaidOrders', {
              page: routeTo.query.p,
              status: routeTo.query.status,
              orderBy: routeTo.query.orderBy,
              merchantAlias: routeTo.query.merchant,
            }),
          ]);

          routeTo.params.orders = currentOrders.items;
          routeTo.params.pagination = currentOrders.pagination;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }
        next();
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      orders: route.params.orders || [],
      pagination: route.params.pagination || {},
    }),
  },
  {
    path: '/member/prepaid/:orderKey',
    name: 'member-prepaid-item',
    component: () => lazyLoadView(import('@views/member-prepaid-item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder
          ] = await Promise.all([
            store.dispatch('booking/fetchPrepaidOrder', {
              orderKey: routeTo.params.orderKey
            }),
          ]);
          store.dispatch('merchant/updateMerchant', currentOrder.merchant);
          routeTo.params.order = currentOrder.items;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }

        next()
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      order: route.params.order || {},
    }),
  },
  {
    path: '/member/prepaid/:orderKey/history',
    name: 'member-prepaid-history',
    component: () => lazyLoadView(import('@views/member-prepaid-history')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder,
          ] = await Promise.all([
            store.dispatch('booking/fetchPrepaidOrder', {
              orderKey: routeTo.params.orderKey
            }),
          ]);
          store.dispatch('merchant/updateMerchant', currentOrder.merchant);
          routeTo.params.order = currentOrder.items;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
        next()
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      order: route.params.order || {},
    }),
  },
  {
    path: '/member/prepaid/:orderKey/applicable',
    name: 'member-prepaid-applicable',
    component: () => lazyLoadView(import('@views/member-prepaid-applicable')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder,
          ] = await Promise.all([
            store.dispatch('booking/fetchPrepaidOrder', {
              orderKey: routeTo.params.orderKey
            }),
          ]);
          store.dispatch('merchant/updateMerchant', currentOrder.merchant);
          routeTo.params.order = currentOrder.items;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
        next()
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      order: route.params.order || {},
    }),
  },
  {
    path: '/member/prepaid/:orderKey/description',
    name: 'member-prepaid-description',
    component: () => lazyLoadView(import('@views/member-prepaid-description')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder,
          ] = await Promise.all([
            store.dispatch('booking/fetchPrepaidOrder', {
              orderKey: routeTo.params.orderKey
            }),
          ]);

          store.dispatch('merchant/updateMerchant', currentOrder.merchant);

          routeTo.params.order = currentOrder.items;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
        next()
      },
      showDingSomethingLogo: true,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      order: route.params.order || {},
    }),
  },
  {
    path: '/prepaidorder/:orderKey',
    name: 'prepaid-order-detail',
    component: () => lazyLoadView(import('@views/order')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(window.globalData.order) {
            next()
          }else {
            const [
              currentOrder,
            ] = await Promise.all([
              store.dispatch('booking/fetchPrepaidOrder', {
                orderKey: routeTo.params.orderKey,
              }),
            ]);

            /* // 只有未付款不用登入
            if(currentOrder.status !== 2) {
              if (store.getters['auth/loggedIn']) {
                // Validate the local user token...
                const validUser = await store.dispatch('auth/validate');
                validUser ? next() : next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
              }
            } */

            routeTo.params.order = currentOrder.items;
            store.dispatch('merchant/updateMerchant', currentOrder.merchant);
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }
      },
      showDingSomethingLogo: false,
      showLoginButton: true,
      authRequired: false,
    },
    props: (route) => ({
      order: route.params.order || {},
      pageType: 'prepaid',
    }),
  },
  {
    path: '/order/:orderKey',
    name: 'order-detail',
    component: () => lazyLoadView(import('@views/order')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(window.globalData.order) {
            next()
          }else {
            const [
              currentOrder,
            ] = await Promise.all([
              store.dispatch('booking/fetchOrder', {
                orderKey: routeTo.params.orderKey,
              }),
            ]);

            /* // 只有未付款不用登入
            if(currentOrder.status !== 2) {
              if (store.getters['auth/loggedIn']) {
                // Validate the local user token...
                const validUser = await store.dispatch('auth/validate');
                validUser ? next() : next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
              }
            } */

            routeTo.params.order = currentOrder.items;
            store.dispatch('merchant/updateMerchant', currentOrder.merchant);
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }
      },
      showDingSomethingLogo: false,
      showLoginButton: true,
      authRequired: false,
    },
      props: (route) => ({
        order: route.params.order || {},
        pageType: 'product',
      }),
    },
  {
    path: '/order/:orderKey/tickets',
    name: 'order-tickets',
    component: () => lazyLoadView(import('@views/order-tickets')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder,
            currentOrderTickets
          ] = await Promise.all([
            store.dispatch('booking/fetchOrder', {
              orderKey: routeTo.params.orderKey,
            }),
            store.dispatch('booking/fetchOrderTickets', {
              orderKey: routeTo.params.orderKey,
            })
          ]);

          routeTo.params.order = currentOrder.items;
          routeTo.params.tickets = currentOrderTickets.items;

          store.dispatch('merchant/updateMerchant', currentOrder.merchant);

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }
      },
      showDingSomethingLogo: false,
      showLoginButton: true,
      authRequired: false,
    },
    props: (route) => ({
      order: route.params.order || {},
      tickets: route.params.tickets || [],
    }),
  },
  {
    path: '/:merchantAlias/summary',
    name: 'booking-summary',
    component: () => lazyLoadView(import('@views/booking-summary')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentMerchant
          ] = await Promise.all([
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
          ]);

          routeTo.params.merchant = currentMerchant.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
      },
      showLoginButton: true,
      showShareButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
    }),
  },
  {
    path: '/:merchantAlias/prepaid',
    name: 'booking-prepaid-list',
    component: () => lazyLoadView(import('@views/booking-prepaid-list')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentPrepaids,
            currentMerchant,
          ] = await Promise.all([
            store.dispatch('merchant/fetchPrepaids', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
          ]);

          routeTo.params.merchant = currentMerchant.items;
          routeTo.params.prepaids = currentPrepaids.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
      },
      showLoginButton: true,
      showShareButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
      prepaids: route.params.prepaids || [],
    }),
  },
  {
    path: '/:merchantAlias/prepaid/:prepaidAlias',
    name: 'booking-prepaid-item',
    component: () => lazyLoadView(import('@views/booking-prepaid-item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentPrepaid,
            currentMerchant,
          ] = await Promise.all([
            store.dispatch('merchant/fetchPrepaid', {
              merchantAlias: routeTo.params.merchantAlias,
              prepaidAlias: routeTo.params.prepaidAlias,
            }),
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
          ]);

          routeTo.params.merchant = currentMerchant.items;
          routeTo.params.prepaid = currentPrepaid.items;

        } catch (error) {
          routeError(error, routeTo, next({ name: 'booking', params: { merchantAlias: routeTo.params.merchantAlias } }));
        }
        next()
      },
      showLoginButton: true,
      showShareButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
      prepaid: route.params.prepaid || [],
    }),
  },
  {
    path: '/:merchantAlias/product/:productId',
    name: 'booking-product',
    component: () => lazyLoadView(import('@views/booking-product')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentProduct,
            currentProductParams,
            currentMerchant,
          ] = await Promise.all([
            store.dispatch('merchant/fetchProduct', {
              productAlias: routeTo.params.productId,
              merchantAlias: routeTo.params.merchantAlias,
            }),
            store.dispatch('merchant/fetchProductParams', {
              productId: routeTo.params.productId,
              merchantAlias: routeTo.params.merchantAlias,
            }),
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
          ]);
          routeTo.params.merchant = currentMerchant.items;
          routeTo.params.product = currentProduct.items;
          routeTo.params.productParams = currentProductParams;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: 'booking', params: { merchantAlias: routeTo.params.merchantAlias } }));
        }
      },
      showLoginButton: true,
      showShareButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
      product: route.params.product || {},
      productParams: route.params.productParams || {},
    }),
  },
  {
    path: '/:merchantAlias/prepaid/:prepaidAlias/checkout',
    name: 'booking-prepaid-checkout',
    component: () => lazyLoadView(import('@views/booking-checkout')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        const cartIsEmpty = Object.keys(store.state.booking.cachedPrepaidCart).length === 0;

        if (cartIsEmpty) {
          next({
            name: 'booking-prepaid-list',
            params: {
              merchantAlias: routeTo.params.merchantAlias,
              prepaidAlias: routeTo.params.prepaidAlias,
            },
          })
        } else {
          try {
            routeTo.params.checkoutCart = store.state.booking.cachedPrepaidCart;

            next()
          } catch (error) {
            routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
          }
        }
      },
      showDingSomethingLogo: false,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      checkoutCart: route.params.checkoutCart || {},
      checkoutType: 'prepaid',
    }),
  },
  {
    // 商品 CheckOut
    path: '/:merchantAlias/product/:productId/checkout',
    name: 'booking-checkout',
    component: () => lazyLoadView(import('@views/booking-checkout')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        const cartIsEmpty = Object.keys(store.state.booking.cachedCart).length === 0;

        if (cartIsEmpty) {
          next({
            name: 'booking-product',
            params: {
              merchantAlias: routeTo.params.merchantAlias,
              productId: routeTo.params.productId,
            },
          })
        } else {
          try {
            routeTo.params.checkoutCart = store.state.booking.cachedCart;

            next()
          } catch (error) {
            routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
          }
        }
      },
      showDingSomethingLogo: false,
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      checkoutCart: route.params.checkoutCart,
      checkoutType: 'product'
    }),
  },
  {
    path: '/:merchantAlias/product/:productId/checkout/:orderKey',
    name: 'booking-unpaid-checkout',
    component: () => lazyLoadView(import('@views/booking-checkout')),
    meta: {
    async beforeResolve(routeTo, routeFrom, next) {
      try {
        const currentOrder = await store.dispatch('booking/fetchOrder', {
          orderKey: routeTo.params.orderKey,
        });

        const { status: currentOrderStatus } = currentOrder.items;

        if (currentOrderStatus !== 2) {
          const statusTextMap = {
            0: '已取消',
            1: '已付款',
          };

          alert(`您的預訂${statusTextMap[currentOrderStatus]}\n系統將重新導向到訂單頁面⋯⋯`);

          next({
            name: 'order-detail',
            params: { orderKey: routeTo.params.orderKey },
          })
        }

        if(currentOrder.items.paymentMethod === 'prepaid' && !currentOrder.items.prepaid) {
          next({
            name: 'order-detail',
            params: { orderKey: routeTo.params.orderKey },
          })
        }

        store.dispatch('merchant/updateMerchant', currentOrder.merchant);

        routeTo.params.order = currentOrder.items;
        routeTo.params.checkoutCart = {
          product: {
            alias: currentOrder.items.productAlias,
            type: currentOrder.items.productType,
            // merchantAlias: currentOrder.merchant.alias,
            name: currentOrder.items.productName,
          },
          paramsPriceTotal: currentOrder.items.priceTotal,
          paramsSizeTotal: currentOrder.items.groupSize,
          params: currentOrder.items.params,
          time: {
            startTime: formatDate(currentOrder.items.startDate, 'time'),
            endTime: formatDate(currentOrder.items.endDate, 'time'),
          },
          date: currentOrder.items.startDate,
          merchantAlias: currentOrder.items.merchant.alias,
          couponInfo: {
            title: currentOrder.items.couponTitle || undefined,
            code: currentOrder.items.couponCode || undefined
          },
          paramsPriceBase: currentOrder.items.priceBase,
          prepaid: currentOrder.items.prepaid
        };

        next()
        } catch (error) {
          routeError(error, routeTo,  next({ name: '404', params: { resource: 'Order' } }));
        }
      },
      showDingSomethingLogo: false,
      authRequired: false,
      showLoginButton: true,
    },
    props: (route) => ({
      order: route.params.order || {},
      checkoutCart: route.params.checkoutCart,
      checkoutType: 'product',
    }),
  },
  {
    path: '/:merchantAlias/prepaid/:prepaidId/checkout/:orderKey',
    name: 'booking-prepaid-unpaid-checkout',
    component: () => lazyLoadView(import('@views/booking-checkout')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const currentOrder = await store.dispatch('booking/fetchPrepaidOrder', {
            orderKey: routeTo.params.orderKey,
          });

          const { status: currentOrderStatus } = currentOrder.items;

          if (currentOrderStatus !== 2) {
            const statusTextMap = {
              0: '已取消',
              1: '已付款',
            };

            alert(`您的預付方案${statusTextMap[currentOrderStatus]}\n系統將重新導向到訂單頁面⋯⋯`);

            next({
              name: 'order-detail',
              params: { orderKey: routeTo.params.orderKey },
            })
          }

          store.dispatch('merchant/updateMerchant', currentOrder.merchant);

          routeTo.params.order = currentOrder.items;
          routeTo.params.checkoutCart = {
            alias: currentOrder.items.prepaid.alias,
            name: currentOrder.items.prepaid.title,
            price: currentOrder.items.price,
            basePrice: currentOrder.items.basePrice,
            times: currentOrder.items.times,
          };

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }
      },
      showDingSomethingLogo: false,
      showLoginButton: true,
      authRequired: false,
    },
    props: (route) => ({
      order: route.params.order || {},
      checkoutCart: route.params.checkoutCart,
      checkoutType: 'prepaid',
    }),
  },
  {
    path: '/:merchantAlias',
    name: 'booking',
    component: () => lazyLoadView(import('@views/booking')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentMerchant,
            currentProducts
          ] = await Promise.all([
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
            store.dispatch('merchant/fetchProducts', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
          ]);

          routeTo.params.merchant = currentMerchant.items;
          routeTo.params.products = currentProducts;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
      },
      showShareButton: true,
      showLoginButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
      products: route.params.products || [],
    }),
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]


function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 5000,
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}

function routeError(error, routeTo, callback) {
  console.log('TCL: Route -> error', error);

  if(error.code === 405 || error.code === 401) {
    store.dispatch('auth/logOut');

    window.location = `/login?redirectFrom=${routeTo.path}`;
  }else {
    return callback
  }
}
